import React from 'react';
import { Container } from 'reactstrap';
import GuidedDTCFlow from '../components/DTC/GuidedDTCFlow';

const ShopDTC = ({ dtc }) => {
    // code/logic/vars here

    return (
        <Container>
            <GuidedDTCFlow />

            {/* ADD LOADS OF MARKETING WITH AEM */}
        </Container>
    );
};

export default ShopDTC;
